const $BP_L = 1024; // PC
const $BP_M = 768;  // TB
const $BP_S = 480;  // SP
const currentWidth = $(window).width();
const activeClass = 'js-active';
let lenis = null;

/**
 * Lenis初期化
 */
const initLenis = () => {
    // 初期化
    lenis = new Lenis(
        {
            // syncTouch: true, // タッチイベントでも慣性スクロールを有効にする
        }
    );

    // Lenisのスクロールイベントに合わせて全てのScrollTriggerインスタンスをアップデート
    lenis.on('scroll', ScrollTrigger.update);

    // LenisのrafメソッドをGSAP tickerに追加
    gsap.ticker.add((time) => {
        lenis.raf(time * 1000); // tickerのタイムスタンプの単位は秒なので、ミリ秒に変換
    });

    // レンダリング時にラグが発生した際のアニメーション調整機能を無効化
    gsap.ticker.lagSmoothing(0);
}

/**
 * メニュー
 */
const initMenu = () => {

    const $menuBtn = $('.js-menu-toggle'); // バーガーメニュー
    const $searchBtn = $('.js-search-toggle'); // 検索ボタン
    const $nav = $('.js-nav'); // メニュー
    const $defaultNav = $('.js-default-nav'); // デフォルトメニュー
    const $searchNav = $('.js-search-nav'); // 検索メニュー
    const $categoryBtn = $('.js-category-toggle'); // カテゴリボタン
    const $globalMenuCategory = $('.js-global-menu-category'); // カテゴリメニュー

    // バーガーメニュー開閉
    $menuBtn.on('click', () => {
        $menuBtn.toggleClass(activeClass);
        $nav.toggleClass(activeClass);

        if($menuBtn.hasClass(activeClass)) {
            // メニューを開いた時

            // display:blockにしてからactiveクラスをつける
            $defaultNav.show(10,function() {
                $defaultNav.addClass(activeClass);
            });

            // メニューボタンのaria-expandedをtrueにする
            $menuBtn.attr('aria-expanded', 'true');

            // デフォルトメニューのaria-hiddenをfalseにする
            $defaultNav.attr('aria-hidden', 'false');

            // 検索メニューのaria-hiddenをtrueにする
            $searchNav.attr('aria-hidden', 'true');
        } else {
            // メニューボタンのaria-expandedをfalseにする
            $menuBtn.attr('aria-expanded', 'false');

            // メニューを閉じた時
            if($defaultNav.hasClass(activeClass)) {
                // display:noneにしてからactiveクラスを外す
                $defaultNav.removeClass(activeClass);
                $defaultNav.delay(350).queue(function(){
                    $(this).hide().dequeue();
                });

                // デフォルトメニューのaria-hiddenをtrueにする
                $defaultNav.attr('aria-hidden', 'true');
            }

            if($searchNav.hasClass(activeClass)) {
                // display:noneにしてからactiveクラスを外す
                $searchNav.removeClass(activeClass);
                $searchNav.delay(350).queue(function(){
                    $(this).hide().dequeue();
                });

                // 検索ボタンのaria-expandedをtrueにする
                $searchBtn.attr('aria-expanded', 'false');

                // 検索メニューのaria-hiddenをtrueにする
                $searchNav.attr('aria-hidden', 'true');
            }

        }
    });

    // 検索ボタンクリック
    $searchBtn.on('click', () => {

        // 検索ボタンのaria-expandedをtrueにする
        $searchBtn.attr('aria-expanded', 'true');

        if($nav.hasClass(activeClass)) {
            // すでにメニューが開いている場合

            // display:noneにしてからactiveクラスを外す
            $defaultNav.removeClass(activeClass);
            $defaultNav.delay(350).queue(function(){
                $(this).hide().dequeue();
            });

            // 検索メニューを表示してからactiveクラスをつける
            $searchNav.show(10,function() {
                $searchNav.addClass(activeClass);
            });

            // デフォルトメニューのaria-hiddenをtrueにする
            $defaultNav.attr('aria-hidden', 'true');

            // 検索メニューのaria-hiddenをfalseにする
            $searchNav.attr('aria-hidden', 'false');
        } else {
            // メニューが閉じている場合

            $menuBtn.addClass(activeClass);
            $nav.addClass(activeClass);

            // 検索メニューを表示してからactiveクラスをつける
            $searchNav.show(10,function() {
                $searchNav.addClass(activeClass);
            });

            // メニューボタンのaria-expandedをtrueにする
            $menuBtn.attr('aria-expanded', 'true');

            // デフォルトメニューのaria-hiddenをtrueにする
            $defaultNav.attr('aria-hidden', 'true');

            // 検索メニューのaria-hiddenをfalseにする
            $searchNav.attr('aria-hidden', 'false');
        }
    });

    // カテゴリメニュー開閉
    $categoryBtn.on('click', () => {
        $categoryBtn.toggleClass(activeClass);
        $globalMenuCategory.slideToggle(activeClass);

        // カテゴリメニューのaria-hiddenをtoggleする
        $categoryBtn.attr('aria-expanded', $categoryBtn.attr('aria-expanded') === 'true' ? 'false' : 'true');
        $globalMenuCategory.attr('aria-hidden', $globalMenuCategory.attr('aria-hidden') === 'true' ? 'false' : 'true');
    });

}

/**
 * アコーディオン
 */
const initAccordion = () => {
}

/**
 * タブ、セレクト切り替え
 */
const initTab = () => {
}

/**
 * inview
 */
const initInview = () => {
    $('.js-inview').aemInview({
        offset: '50%',
        // test: 'aqua',
        scrollEnd: true,
    });
}

/**
 * aemプラグイン初期化
 */
const initAemPlugins = () => {
    $('.aem-post').find('iframe').wrap('<div class="movie-wrapper"></div>');
    $('.aem-post').find('table').wrap('<div class="table-wrapper"></div>');
    $('a[href^="#"]').not('.no-scroll').aemSmoothScroll();
    $('.js-accordion').aemAccordion({
        openHash: true,
        openCallback: function(body) {
            const $this = $(this);
            const $body = $(body);
            // タイトルのaria-expandedをtrueにする
            $this.attr('aria-expanded', 'true');
            // ボディのaria-hiddenをfalseにする
            $body.attr('aria-hidden', 'false');
        },
        closeCallback: function(body) {
            const $this = $(this);
            const $body = $(body);
            // タイトルのaria-expandedをfalseにする
            $this.attr('aria-expanded', 'false');
            // ボディのaria-hiddenをtrueにする
            $body.attr('aria-hidden', 'true');
        }
    });
}

/**
 * ファンシーボックス初期化
 */
const initFancybox = () => {
    $('[data-fancybox]').fancybox({
        protect: true,
        loop: true,
        toolbar: true,
        smallBtn: false,
        autoFocus: false,
        buttons: [
            "close"
        ],
        baseTpl:
        '<div class="fancybox-container" role="dialog" tabindex="-1">' +
            '<div class="fancybox-bg"></div>' +
            '<div class="fancybox-inner">' +
                '<div class="fancybox-infobar"><span class="fancybox-infobar__pagination-current" data-fancybox-index></span><div class="fancybox-infobar__bar"><span class="bar"></span></div><span class="fancybox-infobar__pagination-total" data-fancybox-count></span></div>' +
                '<div class="fancybox-toolbar">{{buttons}}</div>' +
                '<div class="fancybox-navigation">{{arrows}}</div>' +
                '<div class="fancybox-stage"></div>' +
                '<div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div>' +
            '</div>' +
        '</div>',
        afterShow: function (instance, current) {
            $('.fancybox-infobar__bar').each(function () {
                $(this).css('--current' , current.index + 1);
                $(this).css('--total' , instance.group.length);
            });
        }
    });
}

/**
 * 下層時の見出しとセクションのアニメーション
 */
const initPagesAnimation = () => {

    // 大見出しとセクションの大元を取得
    const $title = $('.js-content-section-title');
    const $titleMain = $('.js-content-section-title-main');
    const $pagesContent = $('.js-content-section');

    if($title && $title.length > 0) {
        // 大見出しがあった場合

        // 大見出しのアニメーションが終わったらセクションの大元にactiveクラスを追加
        $titleMain.on("animationend", () => {
            // セクションの大元がない場合は起きないはずだが一応...
            if($pagesContent && $pagesContent.length > 0) {
                // セクションの大元があった場合
                $pagesContent.addClass('js-active');
            }
        });

        // 対象にアニメーション開始のclassをつける
        $title.addClass('js-active');

    } else {
        // 大見出しがない場合はセクションの大元にactiveクラスを追加
        if($pagesContent && $pagesContent.length > 0) {
            $pagesContent.addClass('js-active');
        }
    }
}

// セレクトボックスで有効な選択肢を選んだらボタンを活性化する
function changeSelect() {
    var $button = $('.js-cart-button');
    var $selected = $('.js-cart-detail-select').find('option:selected');

    if ($selected.attr('disabled')) {
        $button.addClass('button--disabled');
    } else {
        $button.removeClass('button--disabled');
    }
}

$(function () {
    initLenis();
    initAemPlugins();
    initFancybox();
    initMenu();
    initInview();
    initPagesAnimation();
})
